// 续年度服务津贴
export default {
  data() {
    return {
      formData:{},
      payPeriodFull: '', //是否至至交费期满（1 是 0 否）
      list: [], //列表数据
      allIndexList: [], //表头全部选项
      indexList: [] //当前配置的表头
    };
  },
  methods: {
    async initData(init) {
      const close = this.$notice.loading();
      await this.getPlanInfo();
      this.allIndexList = [];
      for (let i = 2; i <= 30; i++) {
        this.allIndexList.push({
          id: i,
          name: `第${this.$units.numberTransform(i)}年`
        });
      }
      this.tableItem.programBaseList.forEach(bean => {
        bean.factors.forEach(bean2 => {
          bean[bean2.roleCode] = bean2.remark;
        });
      });
      this.$http({
        url: '/buz/upcommission/queryConfigRenewalCommission',
        type: 'POST',
        data: {
          productCode: this.topItem.productCode,
          isMain: this.tableItem.isMain,
          gradeCode: this.tableItem.gradeCode
        }
      })
        .then(res => {
          if (res.data && res.data.renewProgramCommissionList && res.data.indexList && res.data.indexList.length) {
            this.formData = res.data;
            this.indexList = res.data.indexList.map(i => ({
              id: i,
              key: 'i' + i,
              name: `第${this.$units.numberTransform(i)}年`
            }));
            this.payPeriodFull = res.data.payPeriodFull;
            const list = JSON.parse(JSON.stringify(this.tableItem.programBaseList));
            list.forEach((item, i)=>{
              item.key = 'a' + i;
              item.programId = item.id;
              item.renewCommissionList = this.indexList.map(item=>{
                return {
                  commissionIndex: item.id,
                  commission: 0,
                }
              })
              res.data.renewProgramCommissionList.forEach(item2 => {
                if(item.programId == item2.programId) {
                  item.renewCommissionList = item2.renewCommissionList;
                }
              });
            })
            this.list = list;
          } else if (init) {
            this.formData = {};
            this.indexList = [{}];
            const list = JSON.parse(JSON.stringify(this.tableItem.programBaseList));
            list.forEach(item=>{
              item.programId = item.id;
              item.renewCommissionList = [{}]
            })
            this.list = list
          } else{
            this.list = [];
          }
          this.visible = true;
        })
        .finally(() => {
          close();
        });
    }
  }
};
